import {
  AlignLeft,
  BadgeCheck,
  CircleCheck,
  Code,
  Columns2,
  Globe,
  HandCoins,
  HandHeart,
  Image,
  Info,
  Landmark,
  Layers,
  LayoutList,
  LayoutTemplate,
  ListChecks,
  MousePointerClick,
  Package,
  PackagePlus,
  Palette,
  Receipt,
  ShieldCheck,
  SquareStack,
  Tag,
  TextCursorInput,
  Ticket,
  TicketPercent,
  Type,
} from 'lucide-react';

export const DESIGN_SECTION_ICONS = {
  layout: LayoutTemplate,
  theme: Palette,
  global: Globe,
  columns: Columns2,
  cards: SquareStack,
  'custom-labels': Type,
  'custom-css': Code,
  logo: Image,
  product: Package,
  prices: Tag,
  'price-options': ListChecks,
  pwyw: HandCoins,
  description: AlignLeft,
  details: Info,
  variants: Layers,
  'order-bumps': PackagePlus,
  'ticket-types': Ticket,
  statusBadges: BadgeCheck,
  fields: TextCursorInput,
  'discount-code': TicketPercent,
  'manual-payments': Landmark,
  'price-breakdown': Receipt,
  'cover-processing-fees': HandHeart,
  button: MousePointerClick,
  'trust-badges': ShieldCheck,
  confirmation: CircleCheck,
};

export const DESIGN_GROUP_ICONS = { Sections: LayoutList };
